
  import {
    Component,
    Vue
  } from "vue-property-decorator";
  import PageFooter from '@/components/page-footer.vue';
  import Dialog from '@/components/dialog.vue';

  @Component({
    name: 'sales-record',
    components: {
      PageFooter,
      'slz-dialog': Dialog
    }
  })
  export default class SalesRecord extends Vue {
    private productKey = '';
    private supplierKey = '';
    private list: any = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    private showAddressInfo = false;
    private showCheckLog = false;

    private showInfo() {
      this.showAddressInfo = true;
    }

    private showLog() {
      this.showCheckLog = true;
    }

    private handleClose() {
      this.showAddressInfo = false;
      this.showCheckLog = false;
    }
  }
